// extracted by mini-css-extract-plugin
module.exports = {"body":"ShowImgFile_body__2tuOa","header":"ShowImgFile_header__hHTTM","gobackImgBox":"ShowImgFile_gobackImgBox__1c1kb"};